import { c as _c } from "react/compiler-runtime";
import { Button, CodeInline, LinkButton, Popover } from '@onefootprint/ui';
import { useState } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { VERIFIED_MATCH_DOB, VERIFIED_MATCH_OTP, VERIFIED_MATCH_PHONE } from '../../../../test-mode.constants';
import type { EntityCreatorFormValues } from '../../onboarding.types';
import { parseJson5Object, withVaultDataValues } from '../../onboarding.utils';
export const VerifiedMatchTip = () => {
  const $ = _c(49);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "testMode.runMode.entityCreator.verifiedMatch"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t0);
  const {
    control
  } = useFormContext();
  let t1;
  if ($[1] !== control) {
    t1 = {
      name: "vaultData",
      control
    };
    $[1] = control;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    field
  } = useController(t1);
  const [isOpen, setIsOpen] = useState(false);
  let t2;
  if ($[3] !== field) {
    t2 = () => {
      const vaultData = withVaultDataValues(field.value ?? "", {
        "id.phone_number": VERIFIED_MATCH_PHONE,
        "id.dob": VERIFIED_MATCH_DOB
      });
      field.onChange(vaultData);
      setIsOpen(false);
    };
    $[3] = field;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleUse = t2;
  let vaultData_0 = {};
  try {
    vaultData_0 = parseJson5Object(field.value);
  } catch {}
  if (vaultData_0["id.phone_number"] === VERIFIED_MATCH_PHONE && vaultData_0["id.dob"] === VERIFIED_MATCH_DOB) {
    return null;
  }
  let t3;
  if ($[5] !== t) {
    t3 = t(_temp);
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = {
      label: t3,
      value: VERIFIED_MATCH_PHONE
    };
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t(_temp2);
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = {
      label: t5,
      value: VERIFIED_MATCH_DOB
    };
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t) {
    t7 = t(_temp3);
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t7) {
    t8 = {
      label: t7,
      value: VERIFIED_MATCH_OTP
    };
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t4 || $[18] !== t6 || $[19] !== t8) {
    t9 = [t4, t6, t8];
    $[17] = t4;
    $[18] = t6;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  const rows = t9;
  let t10;
  if ($[21] !== t) {
    t10 = t(_temp4);
    $[21] = t;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t) {
    t11 = t(_temp5);
    $[23] = t;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t11) {
    t12 = <p className="text-body-3 text-tertiary">{t11}</p>;
    $[25] = t11;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== rows) {
    t13 = <dl className="flex flex-col gap-2">{rows.map(_temp6)}</dl>;
    $[27] = rows;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t) {
    t14 = t(_temp7);
    $[29] = t;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== handleUse || $[32] !== t14) {
    t15 = <Button size="compact" onClick={handleUse}>{t14}</Button>;
    $[31] = handleUse;
    $[32] = t14;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== t12 || $[35] !== t13 || $[36] !== t15) {
    t16 = <div className="flex flex-col gap-3 p-3 w-[264px]">{t12}{t13}{t15}</div>;
    $[34] = t12;
    $[35] = t13;
    $[36] = t15;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== t) {
    t17 = t(_temp8);
    $[38] = t;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  let t18;
  if ($[40] !== t17) {
    t18 = <LinkButton>{t17}</LinkButton>;
    $[40] = t17;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  let t19;
  if ($[42] !== isOpen || $[43] !== t16 || $[44] !== t18) {
    t19 = <Popover side="bottom" align="start" controlledOpen={isOpen} onControlledOpenChange={setIsOpen} content={t16}>{t18}</Popover>;
    $[42] = isOpen;
    $[43] = t16;
    $[44] = t18;
    $[45] = t19;
  } else {
    t19 = $[45];
  }
  let t20;
  if ($[46] !== t10 || $[47] !== t19) {
    t20 = <div className="gap-x-1.5 text-body-2 text-tertiary md:flex md:flex-wrap md:items-center">{t10}{" "}{t19}</div>;
    $[46] = t10;
    $[47] = t19;
    $[48] = t20;
  } else {
    t20 = $[48];
  }
  return t20;
};
function _temp($) {
  return $.phone;
}
function _temp2($_0) {
  return $_0.dob;
}
function _temp3($_1) {
  return $_1.otp;
}
function _temp4($_2) {
  return $_2.hint;
}
function _temp5($_3) {
  return $_3.description;
}
function _temp6(t0) {
  const {
    label,
    value
  } = t0;
  return <div key={label} className="flex items-center justify-between gap-2"><dt className="text-body-3 text-primary">{label}</dt><dd><CodeInline size="compact" disabled={true}>{value}</CodeInline></dd></div>;
}
function _temp7($_4) {
  return $_4.cta;
}
function _temp8($_5) {
  return $_5.trigger;
}